var render = function render(){var _vm=this,_c=_vm._self._c;return _c('field-list',_vm._b({attrs:{"value":_vm.iValue,"items":_vm.items,"item-text":_vm.itemText,"item-value":_vm.itemValue},on:{"change":function($event){_vm.iValue = $event}}},'field-list',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }